export const HEAD_ACCESS_REQUEST = "HEAD_ACCESS_REQUEST";
export const HEAD_ACCESS_SUCCESS = "HEAD_ACCESS_SUCCESS";
export const HEAD_ACCESS_FAIL = "HEAD_ACCESS_FAIL";
